import axios from 'axios';
import type { ConfiguracaoUsuario } from '../types/topbar.types';

export class TopbarService {
  /**
   * Busca as configurações e o perfil do usuário logado (referente ao mbConfiguracaoUsuario).
   */
  async getConfiguracaoUsuario(): Promise<ConfiguracaoUsuario> {
    try {
      return (await axios.get<ConfiguracaoUsuario>('/usuarios/configuracao')).data;
    } catch (error) {
      console.error('Falha ao obter configuração de usuário:', error);
      throw error;
    }
  }
}